import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import React from "react";
interface RepeaterProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: RepeaterState;
    settings: any;
}

export class RepeaterComponent extends React.Component<RepeaterProps, any>{
    public static get NAME(): string { return "REPEATER"; }
    private repeaterSettingsWrapper: RepeaterState;
    private additionalParams: {} = {};
    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.repeaterSettingsWrapper = new RepeaterState();
        this.repeaterSettingsWrapper.hydrateFromJS(props.settings);
    }

    handleDataChanged = (alldata) => {
        const that = this;
        let data = alldata[this.repeaterSettingsWrapper.dataSource.getDataSourceIdentifier() + this.props.uid];
        if (!data) {
            data = alldata[this.repeaterSettingsWrapper.dataSource.getDataSourceIdentifier()];
        }

        if (data) {
            this.setState({ value: data.Data }, () => {
                for (let x = 0; x < this.state.value.length; x++) {
                    for (let componentId in this.additionalParams) {
                        const comp = this.additionalParams[componentId];
                        if (comp.key == this.state.value[x][this.props.settings.keyField]) {
                            comp.params = this.state.value[x];
                        }
                    }
                }
                this.props.context.loadChildData(this.props.queryParameter, this.additionalParams)
            });
        }
    }

    registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
        this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
    }

    UNSAFE_componentWillMount() {
        this.registerComponent(this.props.uid, null, [this.repeaterSettingsWrapper.dataSource]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const oldDataSourceId = !this.repeaterSettingsWrapper.dataSource ? null : this.repeaterSettingsWrapper.dataSource.getDataSourceIdentifier();

        this.repeaterSettingsWrapper.hydrateFromJS(nextProps.settings);

        if (this.repeaterSettingsWrapper.dataSource && this.repeaterSettingsWrapper.dataSource.getDataSourceIdentifier() != oldDataSourceId) {
            this.registerComponent(this.props.uid, null, [this.repeaterSettingsWrapper.dataSource]);
        }

    }

    getTemplate = (row) => {
        if (!row && this.props.settings.dataUrl) {
            return { __html: "" };
        }
        var template: any = this.props.settings.template;

        try {
            template = kendo.template(template);
            var result: any = template({ row: row, context: this.props.context.variables });
        }
        catch (e) {
            result = '<div style = "color:red">Error in template:' + e.message + '</div>';
        }
        return { __html: result };
    }

    renderComponents = (component, propertyName, index, key, additionalParams) => {
        var newPropertyPath = this.props.rootPropertyPath.slice();
        newPropertyPath.push(propertyName);
        newPropertyPath.push(index);

        let newContext = $.extend({}, this.props.context);

        newContext.registerComponent = (componentId: string, requiredServices: string[], callback: any, additionalParameters: any, datasource: any) => {
            this.props.context.registerComponent(componentId, requiredServices, callback, additionalParams, datasource);
            this.additionalParams[componentId] = { params: additionalParams, key: key };
        }

        var compObj = utility.getComponentBySettings(component, this.props.values, this, this.state.queryParameter, newContext, newPropertyPath, this.props.settings.uid + ':' + key);

        if (compObj) {
            return <div>{compObj}</div>;
        }
    }

    componentWillUnmount() {
        this.props.context.unregisterComponent(this.props.uid);
    }

    render() {
        let allComps = [];
        if (Array.isArray(this.props.settings.rowItems) && this.state.value && this.state.value[0]) {
            const that = this;
            let i = 0;

            let keyField = this.props.settings.keyField;

            if (!keyField || !that.state.value[0][keyField]) {
                return <div style={{ color: "red" }}>REPEATER: Key field is not set or is not in datasource</div>
            }

            for (let x = 0; x < this.state.value.length; x++) {
                const comps = <div key={that.state.value[x][keyField]}>
                    <div dangerouslySetInnerHTML={this.getTemplate(that.state.value[x])}></div>
                    {this.props.settings.rowItems.map(function (component) { return that.renderComponents(component, 'rowItems', i++, that.state.value[x][keyField], that.state.value[x]) })}
                </div>
                allComps = allComps.concat(comps);
            }
        }

        return <react_components.ReactColumn width={this.props.metadataSettings.width}>
            <ErrorBoundary>
                {allComps}
            </ErrorBoundary>
        </react_components.ReactColumn>
    }
};

export class RepeaterState extends propertyTypes.BaseComponentProps {
    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    public dataSource: datasources.Datasource;

    private keyFieldMetadata = new propertyTypes.ColumnProperty("keyField", "Key field", "dataSource");
    public keyField: string;

    private repeaterMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.repeaterMetadata = baseMetaData.concat([this.templateMetadata, datasources.dataSourceMetadata, this.keyFieldMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.repeaterMetadata;
    }
}
